import React from 'react';
import SelectResource from 'components/Resources/IDRRouting/SelectResource'
import { makeStyles, Grid, Card, CardHeader, CardContent } from '@material-ui/core';
import { useStyles as useDynamicFormStyles } from 'components/Shared/DynamicForm';

const useStyles = makeStyles(theme => ({
  root: {
    padding: 16
  }
}));


const IDRRouting = () => {
  const classes = useStyles();
  // load form styles from dynamic forms;
  const formClasses = useDynamicFormStyles();

  return (
    <div className={classes.root}>
      <Grid container justify="center">
        <Grid item xs={12} sm={12} md={12} lg={7} xl={7}>
          <Card className={formClasses.VerticalFormStyle}>
            <CardHeader title="Select Resource" className={formClasses.cardHeader}></CardHeader>
            <CardContent>
              <SelectResource />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  )
};

export default IDRRouting;